<template>
    <TsCard appendClass="bg-[#F3F4F6]">
        <TsRatings :model-value="rating" />
        <TsTypography append-class="mb-4 mt-2">{{ item.description }}</TsTypography>
        <TsMedia append-class="pt-4 border-t">
            <TsMediaStart>
                <div class="border p-2 rounded-full  max-w-max">
                    <TsTypography appendClass="mb-0">{{ item.shortname }}</TsTypography>
                </div>
            </TsMediaStart>
            <TsMediaContent>
                <TsTypography appendClass="text-black mb-0" as="h4">{{ item.name }}</TsTypography>
                <TsTypography appendClass="text-[#6B7280]" as="h5">{{ item.position }}</TsTypography>
            </TsMediaContent>
        </TsMedia>
    </TsCard>
</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);
const TsRatings = defineAsyncComponent(
    () => import('~/components/molecules/TsRatings.vue')
);
const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);
const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

type Item = {
    name: string;
    position: string;
    shortname: string;
    description: string;
}

type Props = {
    item?: Item;
}
const props = withDefaults(defineProps<Props>(), {
    item: () => ({
        name: 'John Carter',
        position: 'positon',
        shortname: 'AB',
        description: 'Lorem ipsum dolor sit amet consectetur. Pellentesque tristique integer ut ipsum aliquet.'
    })
});

const rating = ref(3);
</script>